<template>
  <v-card class="ma-2">
    <v-card-title>Select Organization</v-card-title>
    <v-card-text>
      Welcome to MyQSRSoft! To begin, please select a organization listed below.
      <v-text-field
        v-model="search"
        placeholder="Search by Name or ID"
        clearable
        hide-details
        variant="outlined"
        prepend-inner-icon="mdi-magnify"
      />
      <div v-if="loadingOrgs" class="loading-container">
        <div>
          Loading Orgs
          <v-progress-circular indeterminate />
        </div>
      </div>
      <div v-else-if="loading">
        <div>
          Loading...
          <v-progress-circular indeterminate />
        </div>
      </div>
      <div v-else>
        <v-data-table-virtual
          :headers="headers"
          :items="orgs"
          :search="search"
          height="400"
          item-value="orgId"
          hover
        >
          <template v-slot:item="{ item }">
            <tr @click="setOrg(item)">
              <td>{{ item.orgName }}</td>
              <td>{{ item.clientId }}</td>
            </tr>
          </template>
        </v-data-table-virtual>
      </div>
    </v-card-text>
  </v-card>
</template>

<script setup>
import { watch, ref } from 'vue';
import { useRootStore } from '../stores/root';
import { storeToRefs } from 'pinia';
import { appSyncApolloClient } from '../helpers/api';
import { retrieveTokensAndSetCookies } from '../helpers/token_extraction';
import gql from 'graphql-tag';
import router from '../router';

const emit = defineEmits('update:multiOrgUserSettingOrg');

const search = ref('');
const loading = ref(false);
const loadingOrgs = ref(false);
const headers = [
  { text: 'Name', value: 'orgName' },
  { text: 'Id', value: 'clientId' },
];

const store = useRootStore();
const { user } = storeToRefs(store);
const orgs = ref();

async function setOrg(org) {
  loading.value = true;
  // console.log(org)
  // store.user.organization = org;
  localStorage.setItem('multiOrgUserSelectedOrgId', org.orgId);
  await store.reload();
  await retrieveTokensAndSetCookies();
  const isCommsHub = store.enterpriseClient === 'CommsHub';
  const redirectPath = isCommsHub ? '/commshub/home' : '/home-dashboard';
  await router.replace(redirectPath);
  store.remountApp();
  close();
}

watch(() => user.value, loadOrgsFromIds, { immediate: true });
async function loadOrgsFromIds() {
  if (!user.value.orgIds) {
    orgs.value = user.value?.organizations.filter((x) => !x.inactive);
    return;
  }
  loadingOrgs.value = true;
  try {
    // split the orgIds into chunks of 50
    const arrays = user.value.orgIds.reduce((acc, orgId, i) => {
      const index = Math.floor(i / 50);
      if (!acc[index]) acc[index] = [];
      acc[index].push(orgId);
      return acc;
    }, []);
    const results = await Promise.all(
      arrays.map(async (orgIds) => getOrgsByOrgId(orgIds)),
    );
    orgs.value = results.flat();
  } catch (e) {
    console.error(e);
  } finally {
    loadingOrgs.value = false;
  }
}
async function getOrgsByOrgId(orgIds) {
  const resp = await appSyncApolloClient.query({
    variables: {
      orgIds,
    },
    query: gql`
      query getOrgsByOrgId($orgIds: [String!]) {
        getOrgsByOrgId(orgIds: $orgIds) {
          orgId
          orgName
          clientId
        }
      }
    `,
  });
  return resp.data.getOrgsByOrgId;
}

function close() {
  emit('update:multiOrgUserSettingOrg', false);
}
</script>
<style scoped>
.loading-container {
  width: 100%;
  height: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
